import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const AccountBankDetailsComponent = ({ onInnerFormChange, selectedAccounts }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="BankAccount Holder Name"
            name="BankAccount Holder Name"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'BankAccountInfo.BankAccountHolderName',
                selectedAccounts?.BankAccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.BankAccountInfo?.BankAccountHolderName}
          />
          <InputContainer

            label="IFSC Code"
            name="IFSCCode"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'BankAccountInfo.IFSC_Code',
                selectedAccounts?.BankAccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.BankAccountInfo?.IFSC_Code}
          />
          <InputContainer
            label="BankAccountNumber"
            name="Bank Account Number"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'BankAccountInfo.BankAccountNumber',
                selectedAccounts?.BankAccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.BankAccountInfo?.BankAccountNumber}
          />
        </div>
      }
      expandedPanel="Bank Account Information"
      headerTitle="Bank Account Info"
    />
  </>
)

export default AccountBankDetailsComponent;
